import { render, staticRenderFns } from "./FRM_TrGruposVehiculos.vue?vue&type=template&id=4ab76d38&"
import script from "./FRM_TrGruposVehiculos.vue?vue&type=script&lang=js&"
export * from "./FRM_TrGruposVehiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports